<template>
  <div>
    <el-tabs v-model="type" @tab-click="tabChange">
      <el-tab-pane label="产品推荐" name="AppRecommend"></el-tab-pane>
      <el-tab-pane label="理财直达" name="AppNonstop"></el-tab-pane>
      <el-tab-pane label="挖矿宝介绍" name="AppMiningExplain"></el-tab-pane>
    </el-tabs>

    <div v-show="type == 'AppRecommend'">
      <div class="header-seach-box">
        <el-button type="success" class="toTransLfet" @click="addRecommendBtn()"
          >添加推荐</el-button
        >
      </div>
      <el-card>
        <el-table :data="recommendList">
          <el-table-column label="产品所属" prop="categoryType">
            <template slot-scope="scope">
              <span v-if="scope.row.categoryType === 1"> 理财</span>
            </template>
          </el-table-column>
          <el-table-column label="产品业务类型" prop="productType">
            <template slot-scope="scope">
                {{PRODUCT_TYPE[scope.row.productType]}}
            </template>
          </el-table-column>
          <el-table-column
            label="产品配置Id"
            prop="productConfigId"
          ></el-table-column>
          <el-table-column
            label="产品参数"
            prop="productParam"
          ></el-table-column>
          <el-table-column label="优先级" prop="sort"></el-table-column>
          <el-table-column label="首页显示">
            <template slot-scope="scope">
              <el-switch
                active-color="#13ce66"
                @change="handleHomePageChange(scope.row.id, $event)"
                :value="scope.row.homePage"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="handleEdit(scope.row)"
                >修改</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                size="small"
                @click="handleRemove(scope.row.id)"
              />
            </template>
          </el-table-column>
        </el-table>
        <div class="pager-wrap">
          <pagination
            :size="pager.size"
            :page="pager.page"
            :total="recommendTotal"
            @pageChanged="handlPageChanged"
          >
          </pagination>
        </div>
      </el-card>

      <el-dialog
        title="添加产品推荐"
        class="bk-ui5-dialog"
        :visible.sync="editDialog"
      >
        <el-form ref="form" label-width="150px">
          <el-form-item label-width="180px" label="产品业务类型">
            <el-select v-model="addRecommend.productType" @change="handleChangeProductType" placeholder="请选择" >
            <el-option v-for="item in financialProduct" :key="item.productType" :label="PRODUCT_TYPE[item.productType]" :value="item.productType" >
            </el-option>
          </el-select>
          <el-select v-model="productTypeDetailId" placeholder="请选择">
            <el-option v-for="item in (financialProduct.find(item => item.productType === addRecommend.productType) || {list: []}).list.slice(0)" :key="item.id" :label="(item.coinType || '') +'/' + (item.name || '')" :value="item.id" >
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item label-width="180px" label="优先级">
            <el-input v-model="addRecommend.sort"></el-input>
          </el-form-item>
          <el-form-item label="显示/隐藏">
            <el-switch v-model="addRecommend.homePage" active-color="#13ce66" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialog = false">取 消</el-button>
          <el-button type="primary" @click="editCommitBtn()">提 交</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-show="type == 'AppNonstop'">
        <el-dialog
        title="理财直达修改"
        class="bk-ui5-dialog"
        :visible.sync="editNonstopDialog"
      >
        <el-form ref="form" label-width="150px">
          <el-form-item label-width="180px" label="优先级">
            <el-input v-model="updateNonstop.sort"></el-input>
          </el-form-item>
          <el-form-item label="显示/隐藏">
            <el-switch v-model="updateNonstop.showed" active-color="#13ce66" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialog = false">取 消</el-button>
          <el-button type="primary" @click="editCommitNonstopBtn()">提 交</el-button>
        </div>
      </el-dialog>

      <el-card>
        <el-table :data="nonstopList">
          <el-table-column label="理财产品" prop="productType">
            <template slot-scope="scope">
              {{PRODUCT_TYPE[scope.row.productType]}}
            </template>
          </el-table-column>
          <el-table-column label="优先级" prop="sort"></el-table-column>
          <el-table-column label="显示/隐藏">
            <template slot-scope="scope">
              <el-switch
                active-color="#13ce66"
                :value="scope.row.showed"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="handleNonstopEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
    <div v-show="type == 'AppMiningExplain'">
      <el-card>
        <el-button type="success" class="toTransLfet" @click="refreshProductCache()">刷新理财产品缓存</el-button>
        <el-form ref="form" label-width="150px">
          <el-form-item label-width="180px" label="中文">
            <el-input v-model="miningExplain.zh"></el-input>
          </el-form-item>
          <el-form-item label-width="180px" label="英文">
            <el-input v-model="miningExplain.en"></el-input>
          </el-form-item>
          <el-form-item label-width="180px" label="韩文">
            <el-input v-model="miningExplain.kr"></el-input>
          </el-form-item>
          <el-form-item label-width="180px" label="越南文">
            <el-input v-model="miningExplain.vi"></el-input>
          </el-form-item>
        </el-form>
        <div class="header-seach-box">
            <el-button type="success" class="toTransLfet" @click="commitMiningExplainBtn()">提交</el-button>
        </div>
        
      </el-card>
    </div>
  </div>
</template>

<script>
import api from "../api";
import "../store";
import Pagination from "components/pagination";
import { mapActions, mapGetters, mapState } from "vuex";
import { formatTable } from "../../../common/tools.js";
import {productType} from '../constant';

export default {
  name: "recommend",
  data() {
    return {
      type: "AppRecommend",
      pager: {
        page: 1,
        size: 10,
      },
      editDialog: false,
      editNonstopDialog: false,
      addRecommend: {},
      updateNonstop: {},
      miningExplain: {},
      financialProduct: [],
      productTypeDetailId: '',
      PRODUCT_TYPE: productType
    };
  },
  computed: {
    ...mapState("ProductManage", [
      "recommendList",
      "recommendTotal",
      "nonstopList",
    ]),
    productCoinType() {
        const list = this.financialProduct.find(item => item.productType === this.addRecommend.productType);
        const coinType = list && list.list.find(item => item.id === this.productTypeDetailId).coinType;
        return coinType || '';
    }
  },
  methods: {
    ...mapActions("ProductManage", [
      "getRecommendList",
      "updateRecommendHomePage",
      "createOrUpdateProductRecommed",
      "deleteRecommend",
      "getNonstopList",
      "updateFinancilNonstop",
      "getMiningExplain",
      "updateMiningExplain",
      "refreshFinancialProductCache",
    ]),

    tabChange() {
      if (this.type == "AppRecommend") {
        this.queryRecommendData();
      } else if(this.type == "AppNonstop" ){
        this.queryNonstopList();
      } else {
        this.queryMiningExplain();
      }
    },

    queryMiningExplain() {
        api.getMiningExplain().then(({data}) =>{
            this.miningExplain = data;
        });
    },

    queryFinancialProduct() {
        api.getAllFinancial().then(({data}) =>{
            this.financialProduct = data;

        });
    },

    queryNonstopList() {
      this.getNonstopList();
    },

    queryRecommendData(clr) {
      if (clr) this.pager.page = 1;
      let q = {
        page: this.pager.page,
        size: this.pager.size,
      };
      this.getRecommendList(q);
    },

    handlPageChanged(pagination) {
      this.pager.page = pagination.page;
      this.pager.size = pagination.size;
      this.queryRecommendData();
    },

    handleHomePageChange(recommendId, homePage) {
      this.$confirm("确认要进行此操作吗？", "提示", { type: "warning" }).then(
        () => {
          this.updateRecommendHomePage({ recommendId, homePage }).then(() => {
            this.$message.success("操作成功！");
            this.queryRecommendData();
          });
        }
      );
    },

    addRecommendBtn() {
      this.addRecommend = {};
      this.editDialog = true;
    },

    handleNonstopEdit(nonstop) {
        this.editNonstopDialog=true;
        this.updateNonstop = nonstop;
    },

    handleEdit(recommend) {
      this.editDialog = true;
      this.addRecommend = recommend;
      this.addRecommend.recommendId = recommend.id;
    },

    editCommitBtn() {
      this.addRecommend.productConfigId = this.productTypeDetailId;
      this.addRecommend.productParam = this.productCoinType;
      this.createOrUpdateProductRecommed(this.addRecommend).then(() => {
        this.$message.success("操作成功！");
        this.addRecommend = {};
        this.editDialog = false;
        this.queryRecommendData();
      });
    },

    handleRemove(recommendId) {
      this.$confirm("确认要删除吗？", "提示", { type: "warning" }).then(() => {
        this.deleteRecommend({ recommendId }).then(() => {
          this.$message.success("操作成功！");
          this.queryRecommendData();
        });
      });
    },

    editCommitNonstopBtn(){
        this.updateFinancilNonstop(this.updateNonstop).then(() => {
        this.$message.success("操作成功！");
        this.updateNonstop = {};
        this.editNonstopDialog = false;
        this.queryNonstopList();
      });
    },

    commitMiningExplainBtn() {
        this.updateMiningExplain(this.miningExplain).then(() => {
        this.$message.success("操作成功！");
        this.queryMiningExplain();
      });
    },

    refreshProductCache() {
        this.refreshFinancialProductCache().then(() => {
        this.$message.success("操作成功！");
      });
    },


    handleChangeProductType() {
        this.productTypeDetailId = "";
    }
  },

  mounted() {
    this.queryRecommendData();
    this.queryFinancialProduct();
  },

  components: {
    Pagination,
  },
};
</script>

<style scoped></style>
